import Vue from "vue";
import Vuex from "vuex";
import nanoid from "@/utils/nanoid";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    players: [],
    points: 0,
    gameState: "start",
    morphs: [
      {
        morph:
          "https://upload.wikimedia.org/wikipedia/commons/b/bf/Hillary_Clinton_Arizona_2016_.jpg",
        you: false,
      },
      {
        morph:
          "https://www.welt.de/img/kultur/mobile101290753/2682509427-ci102l-w1024/Shrek-Aufmacher-BM-Lifestyle-Seeburg-jpg.jpg",
        you: true,
      },
    ],
  },
  mutations: {
    UPDATE_PLAYER(state, player) {
      if (!player.id || player.id == "new") {
        player.id = nanoid();
        state.players.push(player);
      } else {
        const index = state.players.findIndex(
          (playerToUpdate) => playerToUpdate.id == player.id
        );
        state.players.splice(index, 1, player);
      }
    },
    SET_STATE(state, gameState) {
      state.gameState = gameState;
    },
    DELETE_PLAYER(state, id) {
      state.players = state.players.filter((player) => player.id != id);
    },
    RESET(state) {
      state.players = [];
    },
  },
  actions: {},
  modules: {},
});
